import { RouterManager } from '@aclass/admin/managers';
import { LeadScoringStory } from '@aclass/admin/storage/actions';
import { IAdminState, ILeadScoringState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class LeadScoringEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:lead-scoring-edit';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ILeadScoringState['editPageRecordId']>(['leadScoringModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(LeadScoringEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = route.params.id;
        this.ngRdx.dispatch(LeadScoringStory.dryRunEditPage(this.id));
    }
}
